import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit {
  showToast: boolean = true
  @Input() type: 'success' | 'warning' | 'danger' | 'info' = 'warning';
  statusMessages: Record<string, string> = {
    success: 'Items with Success status present!',
    danger: 'Items with danger status present!',
    warning: 'Items with warning status present!'
  };
  @Input() message: string = '';
  @Output() close = new EventEmitter<void>();
  iconPaths: any = {
    success: {
      path: 'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z',
      label: 'Check icon'
    },
    danger: {
      path: 'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z',
      label: 'Error icon'
    },
    warning: {
      path: 'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z',
      label: 'Warning icon'
    }
  };

  ngOnInit() {
    console.log('🟢 app-toast affiché avec', this.message, this.type);

    setTimeout(() => {
      this.showToast = !this.showToast
    }, 3000);
  }


  closeToast() {
    this.showToast = false;
  }


}
